var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-column-style" },
    [
      _c(
        "el-collapse",
        [
          _c(
            "el-collapse-item",
            { attrs: { title: "绘图区域" } },
            [
              _c(
                "style-sub-item",
                { attrs: { title: "配色设置" } },
                [
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticClass: "c-column-style-themes" },
                      _vm._l(_vm.dataList, function (item, idx) {
                        return _c(
                          "div",
                          { key: idx, staticClass: "c-column-style-theme" },
                          [
                            _c("el-color-picker", {
                              on: {
                                change: function (color) {
                                  return _vm.handleChange(item, color)
                                },
                              },
                              model: {
                                value: item[_vm.customKey + "seriesColor"],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item,
                                    _vm.customKey + "seriesColor",
                                    $$v
                                  )
                                },
                                expression: "item[customKey + 'seriesColor']",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(item[_vm.customKey + "text"])),
                            ]),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "div",
                  {
                    staticClass: "chart-form-item-warp",
                    staticStyle: { "margin-top": "0" },
                  },
                  [
                    _c("span", { staticClass: "jz-chart-title-label" }, [
                      _vm._v("透明度"),
                    ]),
                    _vm._v(" "),
                    _c("el-slider", {
                      staticStyle: { flex: "1" },
                      model: {
                        value:
                          _vm.selectItem.styleConfig.commongConfig
                            .columnBackgroundOpacity,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.selectItem.styleConfig.commongConfig,
                            "columnBackgroundOpacity",
                            $$v
                          )
                        },
                        expression:
                          "selectItem.styleConfig.commongConfig.columnBackgroundOpacity",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chart-form-item-warp" },
                  [
                    _c("span", { staticClass: "jz-chart-title-label" }, [
                      _vm._v("开启渐变效果"),
                    ]),
                    _vm._v(" "),
                    _c("el-switch", {
                      model: {
                        value:
                          _vm.selectItem.styleConfig.commongConfig
                            .gradientEffect,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.selectItem.styleConfig.commongConfig,
                            "gradientEffect",
                            $$v
                          )
                        },
                        expression:
                          "selectItem.styleConfig.commongConfig.gradientEffect",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "chart-form-item-warp" },
                  [
                    _c(
                      "span",
                      { staticClass: "jz-chart-title-label" },
                      [
                        _vm._v("\n            柱图宽度\n            "),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content:
                                "当您配置的柱体宽度超出最大宽度范围时，该配置将不再生效。",
                              placement: "top",
                              effect: "dark",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-question",
                              staticStyle: {
                                "margin-left": "4px",
                                color: "#909399",
                                cursor: "help",
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-slider", {
                      staticStyle: { flex: "1" },
                      attrs: { "format-tooltip": _vm.formatTooltip },
                      model: {
                        value:
                          _vm.selectItem.styleConfig.commongConfig
                            .columnWidthRatio,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.selectItem.styleConfig.commongConfig,
                            "columnWidthRatio",
                            $$v
                          )
                        },
                        expression:
                          "selectItem.styleConfig.commongConfig.columnWidthRatio",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("legend-style", {
            attrs: {
              config: _vm.selectItem.styleConfig.commongConfig.legendConfig,
            },
          }),
          _vm._v(" "),
          _c(
            "el-collapse-item",
            { attrs: { title: "数据标签" } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "div",
                    { staticClass: "chart-form-item-warp" },
                    [
                      _c("span", { staticClass: "jz-chart-title-label" }, [
                        _vm._v("是否开启"),
                      ]),
                      _vm._v(" "),
                      _c("el-switch", {
                        model: {
                          value:
                            _vm.selectItem.styleConfig.commongConfig.labelConfig
                              .show,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.selectItem.styleConfig.commongConfig
                                .labelConfig,
                              "show",
                              $$v
                            )
                          },
                          expression:
                            "selectItem.styleConfig.commongConfig.labelConfig.show",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "chart-form-item-warp" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value:
                              _vm.selectItem.styleConfig.commongConfig
                                .labelConfig.showAll,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig,
                                "showAll",
                                $$v
                              )
                            },
                            expression:
                              "selectItem.styleConfig.commongConfig.labelConfig.showAll",
                          },
                        },
                        [_vm._v("全量显示")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "chart-form-item-warp" },
                    [
                      _c("span", { staticClass: "jz-chart-title-label" }, [
                        _vm._v("位置"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择",
                            "popper-class": "c-select-style-popper",
                          },
                          model: {
                            value:
                              _vm.selectItem.styleConfig.commongConfig
                                .labelConfig.position,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig,
                                "position",
                                $$v
                              )
                            },
                            expression:
                              "selectItem.styleConfig.commongConfig.labelConfig.position",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "自动", value: "" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "顶部", value: "top" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "底部", value: "bottom" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "中间", value: "middle" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "左侧", value: "left" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "右侧", value: "right" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("text-style", {
                    attrs: {
                      config:
                        _vm.selectItem.styleConfig.commongConfig.labelConfig
                          .textConfig,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }